import type { JSX } from 'react';

interface BirthDetails {
  date: string;
  time: string;
  place: string;
  fullName: string;
  gender: 'Male' | 'Female';
}

interface NavamsaTableProps {
  birthDetails: BirthDetails;
  navamsa: any[];
}

export default function NavamsaTable({ birthDetails, navamsa }: NavamsaTableProps): JSX.Element {
  if (!birthDetails) {
    return <div className="text-center p-6">Birth details missing</div>;
  }

  if (!navamsa) {
    return <div className="text-center p-6">No data found</div>;
  }

  return (
    <div className="space-y-10">
      <div className="border border-[#2DAAFD] rounded-xl p-6 overflow-x-auto">
        <h3 className="font-32 font-semibold font-spectral mb-4 bg-clip-text text-transparent bg-gradient-to-r from-[#082261] to-[#34065c] text-center">NAVAMSA TABLE</h3>

        <table className="min-w-full border-collapse border border-[#2DAAFD] font-18 whitespace-nowrap">
          <thead className="bg-[#001B6B] text-white font-spectral uppercase">
            <tr>
              <th className="border px-3 py-2">Planet</th>
              <th className="border px-3 py-2">Sign</th>
              <th className="border px-3 py-2">House</th>
              <th className="border px-3 py-2">Nakshatra</th>
              <th className="border px-3 py-2">Degree</th>
            </tr>
          </thead>

          <tbody>
            {Array.from({ length: 12 }, (_, i) => {
              const row = navamsa.find((n: any) => n.house === i + 1) ?? {
                house: i + 1,
                planets: [],
                sign: '',
                nakshatra: [],
                degree: [],
              };

              return (
                <tr
                  key={row.house}
                  className={
                    i % 2 === 0 ? 'bg-white' : 'bg-[linear-gradient(to_right,#B7E2FF,#2DAAFD)]'
                  }
                >
                  <td className="border px-3 py-2 text-center whitespace-pre-line border-black">
                    {row.planets.length
                      ? row.planets
                        .map((p: string) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
                        .join('\n')
                      : '-'}
                  </td>

                  <td className="border px-3 py-2 text-center border-black">{row.sign || '-'}</td>

                  <td className="border px-3 py-2 text-center border-black">{row.house}</td>

                  <td className="border px-3 py-2 text-center whitespace-pre-line border-black">
                    {row.nakshatra.length ? row.nakshatra.join('\n') : '-'}
                  </td>

                  <td className="border px-3 py-2 text-center whitespace-pre-line border-black">
                    {row.degree.length
                      ? row.degree.map((d: number) => `${d.toFixed(2)}°`).join('\n')
                      : '-'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
